import React from 'react';
import BasePageContainer from 'src/components/CommonV2Components/BasePageContainer/BasePageContainer';
import MarginsProductGrid from './MarginsProductGrid';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { BEACON_CHART_SPACING } from 'src/components/Layout/Beacon/BeaconProLayoutConsts';
import BeaconComparableSplineChart from 'src/components/BeaconV2Components/BeaconMetricSplineChart/BeaconComparableSplineChart';

/**
 * Sales Margins Page
 */
const MarginsPage = () => {
  return (
    <BasePageContainer>
      <Flex flexDirection="column" gap={BEACON_CHART_SPACING}>
        <BeaconComparableSplineChart indexName="sales" fieldName="retailerGrossMargin" />
        <BeaconComparableSplineChart indexName="sales" fieldName="retailerGrossMarginPercent" />
        <BeaconComparableSplineChart indexName="sales" fieldName="brandCogs" />
        <BeaconComparableSplineChart indexName="sales" fieldName="brandGrossMargin" />
        <BeaconComparableSplineChart indexName="sales" fieldName="brandGrossMarginPercent" />
        <MarginsProductGrid />
      </Flex>
    </BasePageContainer>
  );
};

export default MarginsPage;
